<script>
import { mapGetters } from 'vuex'

export default {
    name: 'AccountNotifications',
    computed: {
        ...mapGetters(['userResource'])
    },
    data() {
        return {
            optInAccount: null,
            optInMarketing: null,
            optInChangesMade: false,
        }
    },
    methods: {
        async onSaveNotifPrefs() {
            this.userResource.attributes.opt_in_account_updates = this.optInAccount
            this.userResource.attributes.opt_in_marketing_updates = this.optInMarketing
            await this.userResource.save()
            this.optInChangesMade = false
        }
    },
    mounted() {
        this.optInAccount = this.userResource.attributes.opt_in_account_updates
        this.optInMarketing = this.userResource.attributes.opt_in_marketing_updates
    }
}
</script>

<template>
    <div>
        <div class="mb-4">
            <h4 class="mb-1">Notifications</h4>
            <p class="text-muted mb-0">Control how and when we contact you.</p>
        </div>
        <b-card>
            <b-form-group class="mb-4">
                <b-form-checkbox v-model="optInAccount" @input="optInChangesMade = true" switch>
                    <span class="font-weight-bold d-block">Account Updates</span>
                    <small class="text-muted">
                        Transactional messages related to your account, orders, or services you've requested — including appointment reminders, order confirmations, and account notifications. Message &amp; data rates may apply. Reply HELP for help or STOP to opt-out.
                    </small>
                </b-form-checkbox>
            </b-form-group>
            <b-form-group class="mb-4">
                <b-form-checkbox v-model="optInMarketing" @input="optInChangesMade = true" switch>
                    <span class="font-weight-bold d-block">Marketing &amp; Promotions</span>
                    <small class="text-muted">
                        Special offers, discounts, and new product updates. Message &amp; data rates may apply. Reply HELP for help or STOP to opt-out.
                    </small>
                </b-form-checkbox>
            </b-form-group>
            <b-button variant="primary" :disabled="!optInChangesMade" @click="onSaveNotifPrefs()">Save Preferences</b-button>
        </b-card>
    </div>
</template>
